var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramFundoBranco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#780000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-307.648 -280.184)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M319.648,280.184a12,12,0,1,0,12,12A12,12,0,0,0,319.648,280.184Zm0,23.192a11.192,11.192,0,1,1,11.193-11.192A11.192,11.192,0,0,1,319.648,303.376Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(309.728 282.263)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2.509,
    cy: 2.509,
    r: 2.509,
    transform: "translate(7.411 7.412)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M323.915,289.109h-4.637a2.708,2.708,0,0,0-2.705,2.7v4.637a2.708,2.708,0,0,0,2.705,2.7h4.637a2.708,2.708,0,0,0,2.705-2.7v-4.637A2.708,2.708,0,0,0,323.915,289.109Zm-2.318,8.114a3.091,3.091,0,1,1,3.091-3.091A3.092,3.092,0,0,1,321.6,297.223Zm3.323-6a.412.412,0,1,1,.412-.412A.411.411,0,0,1,324.92,291.22Z",
    transform: "translate(-311.676 -284.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M319.649,282.263a9.921,9.921,0,1,0,9.92,9.921A9.921,9.921,0,0,0,319.649,282.263Zm5.957,12.155a3.724,3.724,0,0,1-3.724,3.723h-4.468a3.724,3.724,0,0,1-3.724-3.723v-4.469a3.724,3.724,0,0,1,3.724-3.724h4.468a3.724,3.724,0,0,1,3.724,3.724Z",
    transform: "translate(-309.728 -282.263)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramFundoBranco);
export default __webpack_public_path__ + "static/media/instagram_fundo_branco.6368ebe47ab73ed57472071b527d8aad.svg";
export { ForwardRef as ReactComponent };